import React from "react";
import classes from "./PageTitle.module.scss"

const PageTitle = props => {
	return (
		<h1 className={classes.pageTitle}>{props.pagetitle}</h1>
	)
}

export default PageTitle;